import { useLanguage } from '@/context/LanguageContext';

const LanguageSwitcher = ({ className = '' }) => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className={`flex items-center border border-[#E4E4E7] ${className}`} data-testid="language-switcher">
      <button
        onClick={() => setLanguage('tr')}
        className={`px-3 py-1.5 text-xs font-bold tracking-wide transition-colors ${
          language === 'tr'
            ? 'bg-[#0F1B36] text-white'
            : 'bg-white text-[#52525B] hover:text-[#09090B]'
        }`}
        data-testid="lang-tr-btn"
      >
        TR
      </button>
      <button
        onClick={() => setLanguage('en')}
        className={`px-3 py-1.5 text-xs font-bold tracking-wide transition-colors ${
          language === 'en'
            ? 'bg-[#0F1B36] text-white'
            : 'bg-white text-[#52525B] hover:text-[#09090B]'
        }`}
        data-testid="lang-en-btn"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
